import { useCallback, useContext, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom';
import AuthContext from '../../../../auth/AuthContext';
import AlertService from '../../../../services/AlertService';
import QuizService from '../../../../services/QuizService';
import { Skeleton } from 'primereact/skeleton';
import MasterQuizCard from './MasterQuizCard';
import { FaPlus } from 'react-icons/fa';

const MasterQuizzes = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [quizzes, setQuizzes] = useState([]);
  const [permissions, setPermissions] = useState({});
  const authContext = useContext(AuthContext);

  useEffect(() => {
    const quizAccess = authContext.getPermissions("quizmaster");
    if (quizAccess.filter((f) => f.access.includes(1)).length === 0) {
      navigate("/");
    }
    setPermissions({
      showAdd: quizAccess.some(f => f.access.includes(2)),
      showEdit: quizAccess.some(f => f.access.includes(3)),
      showDelete: quizAccess.some(f => f.access.includes(4)),
    });
  }, [authContext, navigate]);

const loadQuizzes = useCallback(async (signal) => { 
    setLoading(true);
    try {
      const data = await QuizService.GetAllQuizzes(
        authContext,
        signal 
      );

      if (signal?.aborted) return;

      if (data.isSuccess) {
        setQuizzes(data.data);
      } else {
        AlertService.error(data.errorMessage);
      }
    } catch (err) {
      if (err.name === "AbortError") return;
    } finally {
      if (!signal?.aborted) setLoading(false);
    }
  }, [authContext]);

useEffect(() => {
    const controller = new AbortController(); 
    loadQuizzes(controller.signal); 
    return () => controller.abort();
  }, [loadQuizzes]);

  const handleAddClick = () => {
    sessionStorage.removeItem("quizId");
    navigate("/masters-quizzes/add");
  };

  return (
    <div className="container-fluid custom-container mt-2">
      {permissions.showAdd && (
        <div className="d-flex justify-content-end mb-3">
          <button className="btn btn-primary py-2" onClick={handleAddClick}>
            <FaPlus className="pb-1 me-1" />Create Quiz
          </button>
        </div>
      )}
      <div className="row g-4 mb-4">
        {loading ? (
          Array.from({ length: 8 }).map((_, idx) => (
            <div key={idx} className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3">
              <div className="card border-0 shadow p-3 p-md-4 h-100"
                style={{  minHeight: "100px" }}
              >
                <center className="d-flex justify-content-center text-center fw-bold w-100 mb-3">
                  <Skeleton width="50%" height="1.5rem" />
                </center>
                <center className="d-flex justify-content-center text-center fw-bold w-100 mb-2">
                  <Skeleton width="90%" height="1.2rem" />
                </center>
                <center className="d-flex justify-content-center text-center fw-bold w-100 mb-3">
                  <Skeleton width="80%" height="1.2rem" />
                </center>
                <div className="progress mb-3" style={{ "height": "5px" }}>
                  <Skeleton width="100%" height="1.2rem" />
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <Skeleton width="20%" height="1.2rem" />
                  <Skeleton width="30%" height="1.2rem" />
                </div>
                <div className="d-flex justify-content-between mb-4">
                  <Skeleton width="20%" height="1.2rem" />
                  <Skeleton width="20%" height="1.2rem" />
                </div>
                <div className="d-flex justify-content-center">
                  <Skeleton width='80%' height="2rem" borderRadius="20px" />
                </div>
              </div >
            </div>
          ))
        ) :
          quizzes.length > 0 ? (
            quizzes.map((quiz, i) => (
              <div
                key={quiz.id}
                className="col-12 col-sm-6 col-md-4 col-lg-4 col-xl-3"
              >
                <MasterQuizCard
                  data={quiz}
                  no={i}
                />
              </div>
            ))
          ) :
            <div className="col-12 text-center">No quizzes available...</div>
        }
      </div>
    </div>
  )
}

export default MasterQuizzes;